export default "__VITE_PUBLIC_ASSET__e48633f2__"